import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ListProps,
  SelectInput,
  TextInput,
  FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';
import useAuthorize from '../hooks/useAuthorize';
import { LEADS_MODULE_ROLES } from '../roles/portalRoles';

const filters = [
  <TextInput label="Search" source="q" alwaysOn key="q" resettable />,
  <TextInput label="Phone" source="phone" key="phone" resettable />,
  <SelectInput
    label="Message status"
    source="message_status"
    key="message_status"
    resettable
    choices={[
      { id: 'sent', name: 'Sent' },
      { id: 'failed', name: 'Failed' },
      { id: 'pending', name: 'Pending' },
    ]}
  />,
  <SelectInput
    label="Follow-up"
    source="follow_up_status"
    key="follow_up_status"
    resettable
    choices={[
      { id: 'pending', name: 'Pending' },
      { id: 'sent', name: 'Sent' },
      { id: 'skipped', name: 'Skipped' },
      { id: 'failed', name: 'Failed' },
    ]}
  />,
];

const StatusChip = ({ value }: { value?: string }) => {
  const status = String(value || 'pending').toLowerCase();
  const colorMap: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
    sent: 'success',
    failed: 'error',
    pending: 'default',
    skipped: 'warning',
  };
  return <Chip label={status} color={colorMap[status] || 'default'} size="small" />;
};

export const MarketListingLeadList: React.FC<ListProps> = (props) => {
  useAuthorize(LEADS_MODULE_ROLES);

  return (
    <List
      {...props}
      filters={filters}
      sort={{ field: 'created_at', order: 'DESC' }}
      perPage={25}
      title="Market listing leads"
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <DateField source="created_at" label="Captured" showTime />
        <TextField source="phone" label="Phone" />
        <TextField source="buyer_name" label="Name" emptyText="-" />
        <TextField source="listing_id" label="Listing ID" />
        <TextField source="listing_title" label="Listing" emptyText="-" />
        <TextField source="utm_source" label="Source" emptyText="-" />
        <TextField source="utm_medium" label="Medium" emptyText="-" />
        <TextField source="utm_campaign" label="Campaign" emptyText="-" />
        <TextField source="message_channel" label="Channel" />
        <FunctionField
          label="Message"
          render={(record: any) => <StatusChip value={record?.message_status} />}
        />
        <FunctionField
          label="Seller alert"
          render={(record: any) => <StatusChip value={record?.seller_notify_status} />}
        />
        <FunctionField
          label="Follow-up"
          render={(record: any) => <StatusChip value={record?.follow_up_status} />}
        />
        <TextField source="message_error" label="Error" emptyText="-" />
      </Datagrid>
    </List>
  );
};

export default MarketListingLeadList;
